import http from "@/http-common";
import Api from "@/api/methods/Api";

class ApiChatbot extends Api {

    createSession(message, noteIds, questionType) {
        const payload = { message, question_type: questionType };
        if (questionType === "NOTE_INSIGHT" && noteIds && noteIds.length) {
            payload.note_ids = noteIds;
        }
        return http.post("/api/chatbot/sessions", payload);
    }

    getUserSessions() {
        return http.get("/api/chatbot/sessions");
    }

    updateSession(sessionId, name) {
        return http.patch(`/api/chatbot/sessions/${sessionId}`, { name });
    }

    deleteSession(sessionId) {
        return http.delete(`/api/chatbot/sessions/${sessionId}`);
    }

    getMessages(sessionId, limit = 20, offset = 0) {
        return http.get(`/api/chatbot/sessions/${sessionId}/messages`, { params: { limit, offset } });
    }

    sendMessage(sessionId, message, noteIds, questionType) {
        const payload = { message, question_type: questionType };
        if (questionType === "NOTE_INSIGHT" && noteIds && noteIds.length) {
            payload.note_ids = noteIds;
        }
        return http.post(`/api/chatbot/sessions/${sessionId}/messages`, payload);
    }

    getHints() {
        return http.get("/api/chatbot/hints");
    }
}

export default new ApiChatbot();
